import styles from "./tile.module.scss";
const Tile = ({ title, children }) => {
  return (
    <div className={styles.tile}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Tile;
